import Model from 'models/Model';
import User from 'models/core/user/Model.User';
import claimEmailSendEmailApi from './sendEmail/Api.ClaimEmail.SendEmail';

export default class ClaimEmail
  extends Model<Model.IClaimEmail>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimEmail>
{
  id: number;
  claimId: number;
  sendDateUtc: string;
  from?: string;
  tos?: Array<string>;
  subject: string;
  body?: string;

  createdById?: number;
  createdBy?: User;
  modifiedById?: number;
  modifiedBy?: User;

  constructor(data: Partial<Model.IClaimEmail> | Utils.FormData<Model.IClaimEmail>, language?: Locale.Languages) {
    super({ createdBy: User, modifiedBy: User }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.subject || this.id.toString(),
      subtitle: this.from,
    };
  }

  static async sendEmail(props: { emailTemplate: Utils.FormData<Model.IClaimEmailTemplate>; claimId: number }) {
    return await claimEmailSendEmailApi({ params: { claimId: props.claimId }, body: props.emailTemplate });
  }
}
